import http from './http'

class ImportInvoice {
  find (id) {
    return http.get(`/import_invoices/${id}`)
  }

  findInvoices (id) {
    return http.get(`/import_invoices/invoices/${id}`)
  }

  save (payload) {
    return http.post('/import_invoices', payload)
  }

  delete (id) {
    return http.delete(`/import_invoices/${id}`)
  }

  rebuild (id) {
    return http.post(`/import_invoices/${id}`)
  }

  sendEvaluationCerc (id) {
    return http.post(`/import_invoices/${id}/send_evaluation_cerc`)
  }
}

export default new ImportInvoice()



// WEBPACK FOOTER //
// ./src/services/import_invoice.js